import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import Logo from "@/components/Logo";

const inputCls = "w-full bg-black/50 border border-smasher-gold/25 rounded-xl px-4 py-3 text-white outline-none focus:border-smasher-gold transition";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setDone(true);
      toast.success("Request received", { description: data.message });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong");
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md panel p-8">
        <div className="flex justify-center mb-6"><Logo compact /></div>
        <h1 className="font-heading font-black uppercase text-3xl text-center text-gradient-gold">Reset Password</h1>
        {done ? (
          <p className="text-center text-slate-300 mt-6" data-testid="forgot-done">If an account exists for that email, a reset link has been generated. In this demo the link is printed to the server logs.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4 mt-6" data-testid="forgot-form">
            <input type="email" required placeholder="Your email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="forgot-email" />
            <button className="btn-gold w-full py-3 rounded-xl font-heading font-black tracking-wide" data-testid="forgot-submit">SEND RESET LINK</button>
          </form>
        )}
        <div className="text-sm mt-4 text-center text-slate-400"><Link to="/login" className="text-smasher-gold hover:text-smasher-orange">Back to login</Link></div>
      </div>
    </div>
  );
}
